import React from 'react';
import './Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarker, faMobile, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import bgImg from '../../images/contact/contact-bg.webp';
import emailjs from '@emailjs/browser';
import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Contact = () => {

    const [open, setOpen] = React.useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_s0fz1px', 'template_zrv1jjs', e.target, 'user_UPvGv8W1WQMxYwvPvrm3R')
            .then((result) => {
                setOpen(true);
                // console.log(result.text);
            }, (error) => {
                alert(error.text);
            });
        e.target.reset();
    };

    return (
        <section className="d-flex align-items-center mt-5 parallax3" id="Contact">
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                    Your message sent!
                </Alert>
            </Snackbar>
            <div className="container contact-block"
                style={{ backgroundImage: `url(${bgImg})`, backgroundSize: 'cover', width: '100%', borderRadius: '0' }}
            >
                {/* <h6 className="text-center ">GET IN TOUCH</h6> */}
                <h2 className="text-center contact-us-title" id="Contact">Contact Us</h2>
                {/* <h2 className="text-center text-primary">|</h2> */}
                <div className="row mt-5 contact">
                    <div className="col-md-4 text-center">
                        <FontAwesomeIcon icon={faMapMarker} />
                        <h4 className='contact-content'>Our Location:</h4>
                        <h6 className='contact-content'>3481 Muradpur, Chittagong</h6>
                    </div>
                    <div className="col-md-4 text-center" style={{ fontSize: '30px' }}>
                        <FontAwesomeIcon icon={faMobile} />
                        <h4 className='contact-content'>Phone Number:</h4>
                        <h6 className='contact-content'>+880-1713692373</h6>
                    </div>
                    <div className="col-md-4 text-center" style={{ fontSize: '30px' }}>
                        <small className="text-center"><FontAwesomeIcon icon={faEnvelope} /></small>
                        <h4 className='contact-content'>Email Address:</h4>
                        <h6 className='contact-content'>ariful.og@gmail.com</h6>
                    </div>

                </div>
                <div className="row mt-5">
                    <div className="col-md-12">
                        <form
                            onSubmit={sendEmail}
                        >
                            <div className="container">
                                <div className="row">
                                    <div className="form-group col-md-6">
                                        <label htmlFor="name" className="text-dark contact-content">Name*</label>
                                        <input required name="name" id="name" className="form-control" defaultValue="Ariful Islam"
                                        />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="email" className="text-dark contact-content">Email*</label>
                                        <input required name="email" className="form-control" id="email"

                                        />
                                    </div>
                                    <div className="form-group col-md-12 mt-2">
                                        <label htmlFor="subject" className="text-dark contact-content">Subject*</label>
                                        <input required name="subject" className="form-control" id="subject"
                                        />
                                    </div>
                                    <div className="form-group col-md-12 mt-2">
                                        <label htmlFor="subject" className="text-dark contact-content">Your Message*</label>
                                        <textarea name="message" required className="form-control" rows="5"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='text-center'>
                                <input className="mt-2 btn btn-warning contact-content" type="submit" />
                            </div>

                        </form>
                    </div>

                </div>
            </div>

        </section>
    );
};

export default Contact;